import { Check } from 'lucide-react';
import styled from 'styled-components';

import { Button } from '../../../../components/atoms/button/button';
import { Modal } from '../../../../components/molecules/modal/modal';
import { UsuarioInterno } from '../../../../types/usuario';

interface Props {
  isOpen: boolean;
  user: UsuarioInterno | null;
  loading?: boolean;
  errorMessage?: string | null;
  onConfirm: () => Promise<unknown> | void;
  onClose: () => void;
}

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const ErrorAlert = styled.div`
  padding: 10px 12px;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.dangerBg};
  border-left: 3px solid ${({ theme }) => theme.colors.danger};
  color: ${({ theme }) => theme.colors.danger};
  font-size: 13px;
`;

export const ActivateUserModal = ({
  isOpen,
  user,
  loading,
  errorMessage,
  onConfirm,
  onClose,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={() => (!loading ? onClose() : undefined)}
    title="Reativar usuário"
    description={user ? `Reativar acesso de ${user.name}?` : undefined}
    size="sm"
    footer={
      <>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={() => onConfirm()}
          loading={loading}
          startIcon={!loading ? <Check size={14} /> : undefined}
          data-testid="activate-action"
        >
          {loading ? 'Ativando…' : 'Ativar'}
        </Button>
      </>
    }
  >
    {user && (
      <Body>
        <p>
          O usuário voltará a poder fazer login no backoffice e usar as
          permissões atribuídas.
        </p>
        {errorMessage && <ErrorAlert role="alert">{errorMessage}</ErrorAlert>}
      </Body>
    )}
  </Modal>
);
